import { ILocalhostRegistry, IApplicationService, IPrinterService } from "../../../domain/localhost";
import { IClipboardService } from "../../../domain/system";
import { IClaioRegistry } from "../../../domain/claio";
import { IConfiguration } from "../../../domain/configuration";
import { IExternalImageRegistry } from "../../../domain/externalImage";
import { IOcojoRegistry } from "../../../domain/ocojo";
import { ApplicationService } from "./ApplicationService";
import { PrinterService } from "./PrinterService";
import { ClipboardService } from "./ClipboardService";
import { ImageClipboardService } from "./ImageClipboardService";
import { IExternalSystemRegistry } from "../../../domain/externalSystem";

export class LocalhostRegistry implements ILocalhostRegistry {
  constructor(private _getConfiguration: () => IConfiguration, private _getToken: () => string, private readonly _claio: IClaioRegistry, private readonly _ocojo: IOcojoRegistry, private readonly _externalImage: IExternalImageRegistry, private readonly _externalSystem: IExternalSystemRegistry) {
  }

  getApplicationService(): IApplicationService {
    return new ApplicationService(this._getToken, this._claio, this._ocojo, this._externalImage, this._externalSystem);
  }

  getPrinterService(): IPrinterService {
    return new PrinterService();
  }

  getClipboardService(): IClipboardService {
    const configuration = this._getConfiguration();
    return new ClipboardService(configuration.behavior.localhost.clipboard.serviceIntervalAsMsec);
  }

  getImageClipboardService(): ImageClipboardService {
    const configuration = this._getConfiguration();
    return new ImageClipboardService(this._getToken, configuration.behavior.localhost);
  }
}
